import { AccountParentGroupedInvoiceDetailPageComponent } from '../invoices/parent-grouped-invoice-detail/parent-grouped-invoice-detail.component';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ClaimGuard, FeatureFlagGuard } from '@lsq-frontend/common-ui';
import { Routes } from '@lsq-frontend/common-ui';
import {
    supplyChainDirectAccountAtlas,
    supplyChainDirectAccountNode
} from '@lsq-frontend/fasttrack-shared/routing-atlas';
import { AccountInvoicesComponent } from '../invoices/invoices.component';
import { BuyerAccountOverviewComponent } from '../overview/overview.component';
import { SupplierDetailsComponent } from '../suppliers/supplier-details/supplier-details.component';
import { AccountSuppliersComponent } from '../suppliers/suppliers.component';
import { SupplyChainDirectAccountComponent } from '../supply-chain-direct-account.component';
import { UiRoutes } from '@lsq-frontend/angular-shared/app-constants';
import { BuyerAccountInvoiceDetailPageComponent } from '../invoice-detail-page/invoice-detail-page.component';
import { BuyerAccountPaymentsComponent } from '../payments/payments.component';
import { AccountPaymentDetailComponent } from '../payment-details/payment-detail.component';

export const routes: Routes = [
    {
        path: UiRoutes.Home,
        component: SupplyChainDirectAccountComponent,
        canActivate: [ClaimGuard],
        data: {
            title: supplyChainDirectAccountNode.title,
            claims: supplyChainDirectAccountNode.claims
        },
        children: [
            {
                path: UiRoutes.Home,
                redirectTo: supplyChainDirectAccountAtlas.SUPPLY_CHAIN_DIRECT_ACCOUNT_OVERVIEW.path,
                pathMatch: 'prefix'
            },
            {
                path: supplyChainDirectAccountAtlas.SUPPLY_CHAIN_DIRECT_ACCOUNT_OVERVIEW.path,
                component: BuyerAccountOverviewComponent,
                canActivate: [ClaimGuard],
                data: {
                    title: supplyChainDirectAccountAtlas.SUPPLY_CHAIN_DIRECT_ACCOUNT_OVERVIEW.title,
                    claims:
                        supplyChainDirectAccountAtlas.SUPPLY_CHAIN_DIRECT_ACCOUNT_OVERVIEW.claims
                }
            },
            {
                path: supplyChainDirectAccountAtlas.SUPPLY_CHAIN_DIRECT_ACCOUNT_INVOICES.path,
                component: AccountInvoicesComponent,
                canActivate: [ClaimGuard],
                data: {
                    title: supplyChainDirectAccountAtlas.SUPPLY_CHAIN_DIRECT_ACCOUNT_INVOICES.title,
                    claims:
                        supplyChainDirectAccountAtlas.SUPPLY_CHAIN_DIRECT_ACCOUNT_INVOICES.claims
                }
            },
            {
                path: supplyChainDirectAccountAtlas.SUPPLY_CHAIN_DIRECT_ACCOUNT_SUPPLIERS.path,
                component: AccountSuppliersComponent,
                canActivate: [ClaimGuard],
                data: {
                    title:
                        supplyChainDirectAccountAtlas.SUPPLY_CHAIN_DIRECT_ACCOUNT_SUPPLIERS.title,
                    claims:
                        supplyChainDirectAccountAtlas.SUPPLY_CHAIN_DIRECT_ACCOUNT_SUPPLIERS.claims
                }
            },
            {
                path: supplyChainDirectAccountAtlas.SUPPLY_CHAIN_DIRECT_ACCOUNT_PAYMENTS.path,
                component: BuyerAccountPaymentsComponent,
                canActivate: [FeatureFlagGuard, ClaimGuard],
                data: {
                    title: supplyChainDirectAccountAtlas.SUPPLY_CHAIN_DIRECT_ACCOUNT_PAYMENTS.title,
                    claims:
                        supplyChainDirectAccountAtlas.SUPPLY_CHAIN_DIRECT_ACCOUNT_PAYMENTS.claims,
                    featureFlags:
                        supplyChainDirectAccountAtlas.SUPPLY_CHAIN_DIRECT_ACCOUNT_PAYMENTS
                            .FeatureFlags
                }
            },
            {
                path:
                    supplyChainDirectAccountAtlas.SUPPLY_CHAIN_DIRECT_ACCOUNT_SUPPLIER_DETAILS.path,
                children: [
                    {
                        path:
                            supplyChainDirectAccountAtlas
                                .SUPPLY_CHAIN_DIRECT_ACCOUNT_SUPPLIER_DETAILS.children
                                .ACCOUNT_SUPPLIER_DETAILS.path,
                        component: SupplierDetailsComponent,
                        canActivate: [ClaimGuard],
                        data: {
                            title:
                                supplyChainDirectAccountAtlas
                                    .SUPPLY_CHAIN_DIRECT_ACCOUNT_SUPPLIER_DETAILS.children
                                    .ACCOUNT_SUPPLIER_DETAILS.title,
                            claims:
                                supplyChainDirectAccountAtlas
                                    .SUPPLY_CHAIN_DIRECT_ACCOUNT_SUPPLIER_DETAILS.children
                                    .ACCOUNT_SUPPLIER_DETAILS.claims
                        }
                    },
                    {
                        path: '',
                        redirectTo:
                            '/' +
                            supplyChainDirectAccountAtlas.SUPPLY_CHAIN_DIRECT_ACCOUNT_SUPPLIERS.path
                    }
                ]
            },
            {
                path:
                    supplyChainDirectAccountAtlas.SUPPLY_CHAIN_DIRECT_ACCOUNT_EARLY_PAYMENT_DETAILS
                        .path,
                children: [
                    {
                        path:
                            supplyChainDirectAccountAtlas
                                .SUPPLY_CHAIN_DIRECT_ACCOUNT_EARLY_PAYMENT_DETAILS.children
                                .ACCOUNT_EARLY_PAYMENT_DETAILS.path,
                        component: AccountPaymentDetailComponent,
                        canActivate: [ClaimGuard],
                        data: {
                            title:
                                supplyChainDirectAccountAtlas
                                    .SUPPLY_CHAIN_DIRECT_ACCOUNT_EARLY_PAYMENT_DETAILS.children
                                    .ACCOUNT_EARLY_PAYMENT_DETAILS.title,
                            claims:
                                supplyChainDirectAccountAtlas
                                    .SUPPLY_CHAIN_DIRECT_ACCOUNT_EARLY_PAYMENT_DETAILS.children
                                    .ACCOUNT_EARLY_PAYMENT_DETAILS.claims
                        }
                    },
                    {
                        path: '',
                        redirectTo:
                            '/' +
                            supplyChainDirectAccountAtlas
                                .SUPPLY_CHAIN_DIRECT_ACCOUNT_EARLY_PAYMENT_DETAILS.path
                    }
                ]
            },

            {
                path:
                    supplyChainDirectAccountAtlas
                        .SUPPLY_CHAIN_DIRECT_ACCOUNT_EARLY_PAYMENT_REMITTANCE_DETAILS.path,
                children: [
                    {
                        path:
                            supplyChainDirectAccountAtlas
                                .SUPPLY_CHAIN_DIRECT_ACCOUNT_EARLY_PAYMENT_REMITTANCE_DETAILS
                                .children.ACCOUNT_EARLY_PAYMENT_REMITTANCE_DETAILS.path,
                        component: AccountPaymentDetailComponent,
                        canActivate: [ClaimGuard],
                        data: {
                            title:
                                supplyChainDirectAccountAtlas
                                    .SUPPLY_CHAIN_DIRECT_ACCOUNT_EARLY_PAYMENT_REMITTANCE_DETAILS
                                    .children.ACCOUNT_EARLY_PAYMENT_REMITTANCE_DETAILS.title,
                            claims:
                                supplyChainDirectAccountAtlas
                                    .SUPPLY_CHAIN_DIRECT_ACCOUNT_EARLY_PAYMENT_REMITTANCE_DETAILS
                                    .children.ACCOUNT_EARLY_PAYMENT_REMITTANCE_DETAILS.claims
                        }
                    },
                    {
                        path: '',
                        redirectTo:
                            '/' +
                            supplyChainDirectAccountAtlas
                                .SUPPLY_CHAIN_DIRECT_ACCOUNT_EARLY_PAYMENT_REMITTANCE_DETAILS.path
                    }
                ]
            },
            {
                path:
                    supplyChainDirectAccountAtlas
                        .SUPPLY_CHAIN_DIRECT_ACCOUNT_INVOICE_TERMS_PAYMENT_DETAILS.path,
                children: [
                    {
                        path:
                            supplyChainDirectAccountAtlas
                                .SUPPLY_CHAIN_DIRECT_ACCOUNT_INVOICE_TERMS_PAYMENT_DETAILS.children
                                .ACCOUNT_INVOICE_TERMS_PAYMENT_DETAILS.path,
                        component: AccountPaymentDetailComponent,
                        canActivate: [ClaimGuard],
                        data: {
                            title:
                                supplyChainDirectAccountAtlas
                                    .SUPPLY_CHAIN_DIRECT_ACCOUNT_INVOICE_TERMS_PAYMENT_DETAILS
                                    .children.ACCOUNT_INVOICE_TERMS_PAYMENT_DETAILS.title,
                            claims:
                                supplyChainDirectAccountAtlas
                                    .SUPPLY_CHAIN_DIRECT_ACCOUNT_INVOICE_TERMS_PAYMENT_DETAILS
                                    .children.ACCOUNT_INVOICE_TERMS_PAYMENT_DETAILS.claims
                        }
                    },
                    {
                        path: '',
                        redirectTo:
                            '/' +
                            supplyChainDirectAccountAtlas
                                .SUPPLY_CHAIN_DIRECT_ACCOUNT_INVOICE_TERMS_PAYMENT_DETAILS.path
                    }
                ]
            },
            {
                path:
                    supplyChainDirectAccountAtlas.SUPPLY_CHAIN_DIRECT_ACCOUNT_PARENT_GROUPED_INVOICE
                        .path,
                children: [
                    {
                        path:
                            supplyChainDirectAccountAtlas
                                .SUPPLY_CHAIN_DIRECT_ACCOUNT_PARENT_GROUPED_INVOICE.children
                                .SUPPLY_CHAIN_DIRECT_ACCOUNT_PARENT_GROUPED_INVOICE_DETAIL.path,
                        component: AccountParentGroupedInvoiceDetailPageComponent,
                        canActivate: [ClaimGuard, FeatureFlagGuard],
                        data: {
                            title:
                                supplyChainDirectAccountAtlas
                                    .SUPPLY_CHAIN_DIRECT_ACCOUNT_PARENT_GROUPED_INVOICE.children
                                    .SUPPLY_CHAIN_DIRECT_ACCOUNT_PARENT_GROUPED_INVOICE_DETAIL
                                    .title,
                            claims:
                                supplyChainDirectAccountAtlas
                                    .SUPPLY_CHAIN_DIRECT_ACCOUNT_PARENT_GROUPED_INVOICE.children
                                    .SUPPLY_CHAIN_DIRECT_ACCOUNT_PARENT_GROUPED_INVOICE_DETAIL
                                    .claims,
                            featureFlags:
                                supplyChainDirectAccountAtlas
                                    .SUPPLY_CHAIN_DIRECT_ACCOUNT_PARENT_GROUPED_INVOICE.children
                                    .SUPPLY_CHAIN_DIRECT_ACCOUNT_PARENT_GROUPED_INVOICE_DETAIL
                                    .featureFlags
                        }
                    },
                    {
                        path: '',
                        redirectTo:
                            '/' +
                            supplyChainDirectAccountAtlas.SUPPLY_CHAIN_DIRECT_ACCOUNT_INVOICES.path
                    }
                ]
            },
            {
                path: supplyChainDirectAccountAtlas.SUPPLY_CHAIN_DIRECT_BUYER_ACCOUNT_INVOICE.path,
                children: [
                    {
                        path:
                            supplyChainDirectAccountAtlas.SUPPLY_CHAIN_DIRECT_BUYER_ACCOUNT_INVOICE
                                .children.BUYER_ACCOUNT_INVOICE_DETAIL.path,
                        component: BuyerAccountInvoiceDetailPageComponent,
                        canActivate: [ClaimGuard],
                        data: {
                            title:
                                supplyChainDirectAccountAtlas
                                    .SUPPLY_CHAIN_DIRECT_BUYER_ACCOUNT_INVOICE.children
                                    .BUYER_ACCOUNT_INVOICE_DETAIL.title,
                            claims:
                                supplyChainDirectAccountAtlas
                                    .SUPPLY_CHAIN_DIRECT_BUYER_ACCOUNT_INVOICE.children
                                    .BUYER_ACCOUNT_INVOICE_DETAIL.claims
                        }
                    },
                    {
                        path: '',
                        redirectTo:
                            '/' +
                            supplyChainDirectAccountAtlas.SUPPLY_CHAIN_DIRECT_ACCOUNT_INVOICES.path
                    }
                ]
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class SupplyChainDirectAccountRoutingModule {}
